import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DashboardExportLogsNro = lazy(() =>
  import("@scenes/ExportLogs").then((module) => ({
    default: module.ExportLogs,
  }))
);

export const dashboardExportLogsNRO: NavigationRoutingObject = {
  Component: DashboardExportLogsNro,
  componentFeatureFlippers: [],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("dashboard-export-logs-nro-heading", "Exports Log"),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, isImpersonating, hasPermission }) => {
    const userCanViewReports = hasPermission("appGroup", {
      permission: "viewReporting",
    });
    const userHasPermission = featureOn("reporting_permissions_update") ? userCanViewReports : true;

    return isImpersonating || userHasPermission;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("export-logs-alt-keyword-1", "exports log")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
};
